import * as effects from 'redux-saga/effects';
import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { subscriptionActions } from '../../actions';
import { SubscriptionsDetailActionPayload } from '@bus/subscription/typedefs';
import { profileActions } from '@bus/profile/actions';

export function* subscriptionsDetail() {
  try {
    yield effects.put(subscriptionActions.startFetching());
    const response: Response = yield effects.apply(api, api.get, [
      { endpoint: 'subscriptions/detail' },
    ]);
    if (!response.ok) {
      yield throwError(response);
    }
    const data: SubscriptionsDetailActionPayload = yield effects.call([
      response,
      'json',
    ]);

    yield effects.put(profileActions.updateSubscription(data));
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(subscriptionActions.stopFetching());
  }
}
